import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CumpleFilterDates, MensajeCumple, UsuarioCumple, UsuarioCumpleFotoData, UsuarioFuncion } from "src/common/cumples";
import { environment } from "src/environments/environment";

@Injectable()
export class CumplesService {

	private readonly CUMPLE_BASE_URL: string = environment.backendUrl + '/cumple';
	private readonly CUMPLES_BY_DATE_URL: string = this.CUMPLE_BASE_URL;
	private readonly ENVIAR_MENSAJE_CUMPLE_URL: string = this.CUMPLE_BASE_URL;
	private readonly FIND_USUARIO_FOTO_URL: string = this.CUMPLE_BASE_URL + '/usuario/foto';
	private readonly FILTER_DATES_URL: string = this.CUMPLE_BASE_URL + '/filter-dates';
	private readonly USUARIO_FUNCIONES_URL: string = this.CUMPLE_BASE_URL + '/usuario/funcion';

	private readonly ID_USUARIO_PARAM: string = "idUsuarioMf";
	private readonly ID_PERSONA_PARAM: string = "idPersona";
	private readonly DATE_PARAM: string = "date";

	constructor( private http: HttpClient ) {
	}

	findCumplesByDate( date: string ): Observable<UsuarioCumple[]> {
		let params: HttpParams = new HttpParams().set( this.DATE_PARAM, date );
		return this.http.get<UsuarioCumple[]>( this.CUMPLES_BY_DATE_URL, { params } );
	}

	enviarMensajeCumple( mensajeCumple: MensajeCumple ): Observable<MensajeCumple> {
		return this.http.post<MensajeCumple>( this.ENVIAR_MENSAJE_CUMPLE_URL, mensajeCumple );
	}

	findUsuarioFoto( idPersona: number ): Observable<UsuarioCumpleFotoData> {
		let params: HttpParams = new HttpParams().set( this.ID_PERSONA_PARAM, idPersona.toString() );
		return this.http.get<UsuarioCumpleFotoData>( this.FIND_USUARIO_FOTO_URL, { params } );
	}

	getFilterDates(): Observable<CumpleFilterDates> {
		return this.http.get<CumpleFilterDates>( this.FILTER_DATES_URL );
	}

	getUsuarioFunciones( idUsuarioMf: number ): Observable<UsuarioFuncion[]> {
		let params: HttpParams = new HttpParams().set( this.ID_USUARIO_PARAM, idUsuarioMf.toString() );
		return this.http.get<UsuarioFuncion[]>( this.USUARIO_FUNCIONES_URL, { params } );
	}

}